import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DashboardStats {
  kontrolltermine_aktuell: number;
  kontrolltermine_bearbeitung: number;
  kontrolltermine_freigabe: number;
  anzahl_kunden: number;
  anzahl_standorte: number;
}

export interface DashboardStatsResponse {
  success: boolean;
  data: DashboardStats;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardStatsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /**
   * Get dashboard statistics
   */
  getStats(): Observable<DashboardStatsResponse> {
    // Try the protected route first, fallback to public test route
    return this.http.get<DashboardStatsResponse>(`${this.apiUrl}/stats`);
  }

  getTestStats(): Observable<DashboardStatsResponse> {
    // Public test route (no authentication required)
    return this.http.get<DashboardStatsResponse>(`http://localhost:8010/proxy/api/test-stats`);
  }
}
